export type Packages = "Medium" | "Platinum";
export const SERVICES: {
    packages: Packages[];
    cs: { title: string; point1: string; point2: string };
    en: { title: string; point1: string; point2: string };
}[] = [
    {
        packages: ["Medium", "Platinum"],
        cs: {
            title: "Společný úvodní workshop",
            point1: "Společně si sedneme a\u00a0projdeme vaše cíle a\u00a0očekávání. ",
            point2: "Výstupem bude plán akcí a\u00a0strategie pro zlepšení uživatelského zážitku. ",
        },
        en: {
            title: "Joint introductory workshop",
            point1: "We will sit down together and go over your goals and expectations.",
            point2: "The output will be an\u00a0action plan and strategy for improving the user experience.",
        },
    },
    {
        packages: ["Medium", "Platinum"],
        cs: {
            title: "Google Analytics",
            point1: "Díky podrobné datové analýze získáte vhled do\u00a0chování uživatelů a\u00a0byznysu.",
            point2: "Výstupem bude přehled o\u00a0klíčových oblastech pro optimalizaci.",
        },
        en: {
            title: "Google Analytics",
            point1: "Thanks to the detailed analysis, you will gain deep insight into the behavior of your users.",
            point2: "The output will be an\u00a0overview of the key areas for optimization.",
        },
    },
    {
        packages: ["Medium", "Platinum"],
        cs: {
            title: "Komentované video expertem",
            point1: "Expertní komentáře k\u00a0vašemu webu vám umožní lépe pochopit klíčové problémy a\u00a0možnosti zlepšení. ",
            point2: "Výstupem je videozáznam UX experta s\u00a0komentovanou analýzou webu, včetně doporučení pro zlepšení.",
        },
        en: {
            title: "Commented video by an\u00a0expert",
            point1: "Expert commentary on your website analysis will help you better understand key issues and opportunities for improvement.",
            point2: "The output will be a\u00a0video where our UX expert provides a\u00a0commented analysis of your website, including the identification of key problems and recommendations for their solution.",
        },
    },
    {
        packages: ["Medium", "Platinum"],
        cs: {
            title: "Wireframing",
            point1: "Vytvoření návrhů wireframů s\u00a0doporučenými změnami a\u00a0optimalizací pro lepší uživatelský zážitek.",
            point2: "Výstupem jsou návrhy doporučených změn a\u00a0optimalizace jako výchozí bod pro úpravy a\u00a0funkcionality s\u00a0cílem vylepšit uživatelský zážitek.",
        },
        en: {
            title: "Wireframing",
            point1: "Creating draft wireframes with recommended changes and optimizations that will lead to a\u00a0better user experience.",
            point2: "The output are proposals of recommended changes and optimizations as a\u00a0starting point for the implementation of new design elements and functionalities with the aim of improving the user experience.",
        },
    },
    {
        packages: ["Medium", "Platinum"],
        cs: {
            title: "Analýza konverzních trychtýřů",
            point1: "Identifikace úzkých míst ve\u00a0vašem konverzním procesu a\u00a0návrhy na\u00a0jejich zlepšení. ",
            point2: "Výstupem bude analýza a\u00a0doporučení pro optimalizaci konverzních trychtýřů.",
        },
        en: {
            title: "Analysis of conversion funnels",
            point1: "Identification of bottlenecks in your conversion process and suggestions for improving them.",
            point2: "The output will be an\u00a0analysis and recommendations for optimizing conversion funnels.",
        },
    },
    {
        packages: ["Medium", "Platinum"],
        cs: {
            title: "Mouse tracking",
            point1: "Díky sledování pohybu myši získáte jasnou představu o\u00a0tom, jak uživatelé interagují s\u00a0vaším webem.",
            point2: "Výstupem bude vizuální zobrazení teplotní mapy a\u00a0identifikace klíčových oblastí zájmu.",
        },
        en: {
            title: "Mouse tracking",
            point1: "With mouse movement tracking, you get a clear idea of how users are interacting with your website.",
            point2: "The output will be a visual display of a\u00a0temperature map and identification of key areas of interest.",
        },
    },
    {
        packages: ["Platinum"],
        cs: {
            title: "Uživatelské testování",
            point1: "Uživatelé vám poskytnou cennou zpětnou vazbu prostřednictvím testování dle předem připravených scénářů.",
            point2: "Výstupem bude zpráva s\u00a0hlavními zjištěními a\u00a0doporučeními z 5\u201310 uživatelských testů.",
        },
        en: {
            title: "User testing",
            point1: "Real users give you valuable feedback through live site testing.",
            point2: "The output will be a\u00a0report with the main findings and recommendations from 5\u201310 user tests.",
        },
    },
    {
        packages: ["Platinum"],
        cs: {
            title: "Analýza konkurence",
            point1: "Analýza konkurence pomáhá porozumět trhu a\u00a0identifikovat konkurenční výhody a\u00a0slabiny.",
            point2: "Výstupem bude komparativní analýza konkurenčního prostředí, která identifikuje silné a\u00a0slabé stránky konkurenčních produktů nebo služeb a\u00a0poskytne podklady pro strategické rozhodování.",
        },
        en: {
            title: "Competitive analysis",
            point1: "Competitive analysis helps to understand the market and identify competitive advantages and weaknesses. ",
            point2: "The output will be a\u00a0comparative analysis of the competitive environment, which identifies the strengths and weaknesses of competing products or services and provides the basis for strategic decision-making.",
        },
    },
    {
        packages: ["Platinum"],
        cs: {
            title: "Strategie A/B testování",
            point1: "Plán A/B\u00a0testů vám pomůže testovat různé varianty designu a\u00a0obsahu a\u00a0identifikovat ty nejefektivnější.",
            point2: "Výstupem bude plán testů zaměřený na\u00a0maximalizaci konverzí.",
        },
        en: {
            title: "A/B testing strategy",
            point1: "An A/B test plan will help you test different design and content variations and identify the most effective ones.",
            point2: "The output will be a\u00a0roadmap of tests focused on maximizing conversions.",
        },
    },
];
